import React from 'react';

export default function IconJP() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#F5F5F5"
                d="M31.449 21.483H.552A.552.552 0 0 1 0 20.93V1.069C0 .764.247.517.552.517H31.45c.304 0 .551.247.551.552v19.862a.552.552 0 0 1-.551.552Z"
            />
            <path
                fill="#FF4B55"
                d="M16 17.069A6.069 6.069 0 1 0 16 4.93a6.069 6.069 0 0 0 0 12.138Z"
            />
        </svg>
    );
}
